import { render, staticRenderFns } from "./BanRequests.vue?vue&type=template&id=66ec37b4&scoped=true&"
import script from "./BanRequests.vue?vue&type=script&lang=js&"
export * from "./BanRequests.vue?vue&type=script&lang=js&"
import style0 from "./BanRequests.vue?vue&type=style&index=0&id=66ec37b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ec37b4",
  null
  
)

export default component.exports